"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VAutocomplete;

var _react = _interopRequireDefault(require("react"));

var _Autocomplete = _interopRequireDefault(require("@material-ui/lab/Autocomplete"));

var _core = require("@material-ui/core");

require("./VAutocomplete.css");

var _VChip = _interopRequireDefault(require("../../Notifications/VChip/VChip"));

var _Icon = _interopRequireDefault(require("../../Graphics/Icon/Icon"));

var _excluded = ["label", "getOptionLabel", "autoFocus", "error", "helperText", "renderTags"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function VAutocomplete(_ref) {
  var label = _ref.label,
      getOptionLabel = _ref.getOptionLabel,
      autoFocus = _ref.autoFocus,
      error = _ref.error,
      helperText = _ref.helperText,
      renderTags = _ref.renderTags,
      rest = _objectWithoutProperties(_ref, _excluded);

  var renderTagsFunc = function renderTagsFunc(tagValue, getTagProps) {
    return tagValue.map(function (option, index) {
      return /*#__PURE__*/_react.default.createElement(_VChip.default, _extends({
        label: getOptionLabel(option)
      }, getTagProps({
        index: index
      })));
    });
  };

  return /*#__PURE__*/_react.default.createElement(_Autocomplete.default, _extends({
    getOptionLabel: getOptionLabel,
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react.default.createElement(_core.TextField, _extends({}, params, {
        label: label,
        variant: "outlined",
        className: "VaalTextField",
        autoFocus: autoFocus,
        error: error,
        helperText: helperText
      }));
    },
    renderTags: renderTags || renderTagsFunc,
    popupIcon: /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: "arrowDown"
    })
  }, rest));
}